import media from './api/media';
import menuItems from './api/menu-items';
import options from './api/options';
import pages from './api/pages';
import posts from './api/posts';
import promo from './api/promo';

export function useWp() {
  const config = useRuntimeConfig();

  const fetch = $fetch.create({
    baseURL: new URL('/wp-json', config.public.rysApiUrl).href
  });

  const wp = {
    media: media(fetch),
    menuItems: menuItems(fetch),
    options: options(fetch),
    pages: pages(fetch),
    posts: posts(fetch),
    promo: promo(fetch)
  };

  return wp;
};
